export const ACTION_PREFIX = 'CHECKOUT_SUMMARY';
export const PARTITION = 'checkoutSummary';

export const actionTypes = {
  GET_CHECKOUT_FULLFILLED: 'GET_CHECKOUT_FULLFILLED',
  GET_CHECKOUT_PENDING: 'GET_CHECKOUT_PENDING',
  GET_CHECKOUT_REJECTED: 'GET_CHECKOUT_REJECTED',
  SET_CHECKOUT_ID: 'SET_CHECKOUT_ID',
};
